"use strict";
/**
 * Copyright 2014-present Palantir Technologies
 * @license MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dispatcher = void 0;
var Utils = require("../utils");
var Dispatcher = /** @class */ (function () {
    function Dispatcher() {
        /**
         * Subclasses set these in constructor. Then, these get attached to the event
         * target in _connect
         *
         * eventname is a DOM event name like "mouseup", "touchstart", etc. The
         * callback is simply registered to the event callback with bubbling.
         */
        this._eventToProcessingFunction = {};
        /**
         * All listeners are registered to this `EventTarget` and events are then
         * dispatched to callbacks from `_eventNameToCallbackSet` manually.
         *
         * Subclasses set their own event target instead of `document`.
         */
        this._eventTarget = document;
        this._eventNameToCallbackSet = {};
        this._connected = false;
    }
    Dispatcher.prototype._hasNoCallbacks = function () {
        var eventNames = Object.keys(this._eventNameToCallbackSet);
        for (var i = 0; i < eventNames.length; i++) { // for-loop so return can break out
            if (this._eventNameToCallbackSet[eventNames[i]].size !== 0) {
                return false;
            }
        }
        return true;
    };
    Dispatcher.prototype._connect = function () {
        var _this = this;
        if (this._connected) {
            return;
        }
        Object.keys(this._eventToProcessingFunction).forEach(function (event) {
            var processingFunction = _this._eventToProcessingFunction[event];
            // Add `{ passive: false }` option because Chrome 73 broke this.
            var options = event === "wheel" ? { passive: false } : undefined;
            _this._eventTarget.addEventListener(event, processingFunction, options);
        });
        this._connected = true;
    };
    Dispatcher.prototype._disconnect = function () {
        var _this = this;
        if (this._connected && this._hasNoCallbacks()) {
            Object.keys(this._eventToProcessingFunction).forEach(function (event) {
                var processingFunction = _this._eventToProcessingFunction[event];
                _this._eventTarget.removeEventListener(event, processingFunction);
            });
            this._connected = false;
        }
    };
    Dispatcher.prototype._addCallbackForEvent = function (eventName, callback) {
        if (this._eventNameToCallbackSet[eventName] == null) {
            this._eventNameToCallbackSet[eventName] = new Utils.CallbackSet();
        }
        this._eventNameToCallbackSet[eventName].add(callback);
        this._connect();
    };
    Dispatcher.prototype._removeCallbackForEvent = function (eventName, callback) {
        if (this._eventNameToCallbackSet[eventName] != null) {
            this._eventNameToCallbackSet[eventName].delete(callback);
        }
        this._disconnect();
    };
    Dispatcher.prototype._callCallbacksForEvent = function (eventName) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var callbackSet = this._eventNameToCallbackSet[eventName];
        if (callbackSet != null) {
            callbackSet.callCallbacks.apply(callbackSet, args);
        }
    };
    return Dispatcher;
}());
exports.Dispatcher = Dispatcher;



//////////////////
// WEBPACK FOOTER
// ./src/dispatchers/dispatcher.ts
// module id = 26
// module chunks = 0